import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';
import Footer_Logo from '../../resources/Footer_Logo.svg';
import Button from '@material-ui/core/Button';
import packageJson from '../../../package.json';
const { version } = packageJson;

const styles = theme => ({
  button: {
    textTransform: 'none',
    color: '#757575',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.09px',
    marginLeft: '2%',
    marginTop: '2px'
  },
  root: {
    width: '100%',
    position: 'absolute',
    bottom: '0'
  },
  grow: {
    flexGrow: 1
  },
  sectionDesktop: {
    display: 'flex',
    alignItems: 'center'
  },
  version: {
    height: '14px',
    color: '#757575',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.09px',
    lineHeight: '14px'
  },
  copyRight: {
    color: '#757575',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.09px',
    lineHeight: '14px',
    width: '200px'
  },
  toolBar: {
    marginLeft: '5%',
    marginRight: '4%',
    minHeight: 'unset',
    padding: '6px 0px'
  },
  appBar: {
    backgroundColor: 'transparent',
    border: '1px solid #DADCE0',
    boxShadow: 'none',
    height: '3rem'
  },
  CopyRightbutton: {
    textTransform: 'none',
    color: '#757575',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.09px',
    marginLeft: '2%',
    marginTop: '2px'
  }
});

class Footer extends React.Component {
  state = {};

  handlePrivacy = () => {
    window.open('https://www.qikserve.com/privacy', '_blank');
  };

  handleTermsAndConditions = () => {
    window.open('https://www.qikserve.com/eula', '_blank');
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <AppBar id="footerStyle" position="static" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <img
              style={{ marginTop: '2px' }}
              src={Footer_Logo}
              alt="Footer_Logo"
            />
            <Button onClick={this.handlePrivacy} className={classes.button}>
              Privacy Policy
            </Button>
            <Button
              className={classes.button}
              onClick={this.handleTermsAndConditions}
            >
              EULA
            </Button>
            <div className={classes.grow} />
            <div>
              <div className={classes.sectionDesktop}>
                <Button
                  disabled
                  className={classes.CopyRightbutton}
                  onClick={this.handleTermsAndConditions}
                >
                  <div
                    className={classes.copyRight}
                  >{`\u00A9 Copyright Qikserve Ltd, ${new Date().getFullYear()}`}</div>
                </Button>
                <div className={classes.version}>{`v${version}`}</div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Footer);
